// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__M9N6A","header-wrapper":"Layout_header-wrapper__rKGbi","header":"Layout_header__pDGjk","main-wrapper":"Layout_main-wrapper__1UbNU","main":"Layout_main__Pmq7p"};